export default __webpack_public_path__ + "static/media/bannerSmall9.fea78a1b.png";